import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SalaryTemplatePipelineBar from "./SalaryTemplatePipelineBar";
import PipelineCtcSection from "./PipelineCtcSection";
import {
  PIPELINE_STEPS,
  pipelineStepPath,
  readPipelineState,
  writePipelineState,
} from "./salaryTemplatePipeline";
import { useToast } from "../../../../Context/ToastContext";

export default function SalaryTemplatePipelineCtc() {
  const navigate = useNavigate();
  const toast = useToast();
  const [saving, setSaving] = useState(false);

  function continueToReview() {
    const state = readPipelineState();
    const annual = Number(state.targetAnnualCtc);
    if (!Number.isFinite(annual) || annual <= 0) {
      toast.error("Enter a valid annual gross salary.");
      return;
    }
    setSaving(true);
    try {
      if (state.returnToReview) {
        writePipelineState({ returnToReview: false, currentStep: PIPELINE_STEPS.review });
      } else {
        writePipelineState({ currentStep: PIPELINE_STEPS.review });
      }
      navigate(pipelineStepPath(PIPELINE_STEPS.review));
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <SalaryTemplatePipelineBar currentStep={PIPELINE_STEPS.ctcAllocation} />
      <section className="stp-card">
        <h2 className="stp-section-title">Step 4 — Gross salary</h2>
        <p className="stp-section-hint">
          Set the annual gross salary and check that the component formulas balance.
        </p>
        <PipelineCtcSection
          onTargetChange={(annual) => {
            writePipelineState({ targetAnnualCtc: annual, currentStep: PIPELINE_STEPS.ctcAllocation });
          }}
        />
        <div className="stp-pipeline-sticky">
          <button
            type="button"
            className="stp-btn stp-btn-ghost"
            onClick={() => navigate(pipelineStepPath(PIPELINE_STEPS.formulas))}
          >
            Back to formulas
          </button>
          <button
            type="button"
            className="stp-btn stp-btn-primary"
            disabled={saving}
            onClick={continueToReview}
          >
            Next: Review → <ArrowRight size={16} />
          </button>
        </div>
      </section>
    </>
  );
}
